import { useEffect } from 'react'
import { useOrganization } from '../context/OrganizationContext'

/** Ensures the organization list is loaded once when the dashboard shell mounts. */
export function useOrganizationLoader() {
  const { fetchOrganizations } = useOrganization()

  useEffect(() => {
    fetchOrganizations({ page: 1, limit: 50 }).catch(() => {})
  }, [fetchOrganizations])
}
